import { Media } from "./media";

export interface Competition {
    id: number;
    name: string;
    description: string;
    date_start: string;
    date_end: string;
    date_description: string;
    venue_name: string;
    venue_link: string;
    documents: Media[];
    color: string;
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyCompetition: Competition = {
    id: 0,
    name: '',
    description: '',
    date_start: '0000-00-00',
    date_end: '0000-00-00',
    date_description: '',
    venue_name: '',
    venue_link: '',
    documents: [],
    color: '',
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}